import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toggleSideBarMobile, setSearch } from '../store/reducers/general'
import { TeamSelector } from './team-selector'
import { ThemeSelector } from './theme-selector'
const isMobile = window.innerWidth < 700

export const Header = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user = useSelector(state => state.user)
    const { sideBarMobile } = useSelector(state => state.general)
    const [localSearch, setLocalSearch] = useState('')
    const { search } = useSelector(state => state.general)
    const roles = user?.currentTeam?.members?.find(member => member._id === user._id)?.roles || []

    useEffect(() => {
        if (search === '') setLocalSearch('')
    }, [search])

    if (isMobile) return <>
        <header className='header'>
            <span className="material-symbols-outlined open-sidebar" onClick={() => dispatch(toggleSideBarMobile())}>menu</span>
            <img src={require(`../style/imgs/logo.webp`)} className='logo' onClick={() => navigate('/')} />
        </header >
        {sideBarMobile && <div className="side-bar">
            <div onClick={() => { navigate('/'); dispatch(toggleSideBarMobile()) }} className='item'>
                <span className="material-symbols-outlined">home</span>
                <p>בית</p>
            </div>
            {user.name && <div onClick={() => { navigate('/profile'); dispatch(toggleSideBarMobile()) }} className='item'>
                <img src={user.img} />
                <p>פרופיל</p>
            </div>}
            {(roles.includes('admin') || roles.includes('ideaMaker')) && <div className='item' onClick={() => { dispatch(toggleSideBarMobile()); navigate('/create') }}>
                <img src={require(`../style/imgs/idea.webp`)} style={{ borderRadius: '0', width: '24px', objectFit: 'contain' }} />
                <p>רעיון חדש</p>
            </div>}
            <TeamSelector />
            <span className="material-symbols-outlined close" onClick={() => dispatch(toggleSideBarMobile())}>chevron_right</span>
        </div>}
    </>

    return <header className='header'>
        <nav>
            <img src={require(`../style/imgs/logo.webp`)} className='logo' onClick={() => navigate('/')} />
            {(roles.includes('admin') || roles.includes('ideaMaker')) && <div style={{ marginRight: '25px' }} className='new-idea arise' onClick={() => navigate('/create')}>
                <img src={require(`../style/imgs/idea.webp`)} />
                <p>רעיון חדש</p>
            </div>}
        </nav>

        {(user._id && user.currentTeam?._id) && <div className='search-wrapper' >
            <form className='search search-he' onSubmit={(ev) => { ev.preventDefault(); dispatch(setSearch(localSearch)); navigate('/') }}>
                <input type="text" style={{ textAlign: 'right' }} placeholder='חפש סרטון לפי כותרת או מיקום' onChange={(ev) => setLocalSearch(ev.target.value)} value={localSearch} />
                {localSearch && <span className="material-symbols-outlined x" onClick={() => { dispatch(setSearch('')); setLocalSearch('') }}>close</span>}
                <button>
                    <img src={require(`../style/imgs/header/dark/search.webp`)} />
                </button>
            </form>
        </div>}

        {user._id && <nav>
            <ThemeSelector />
            <TeamSelector />
        </nav>}
    </header >
}